import Vue from 'vue'
import App from './App'
import router from './router'
import toast from './components/toast/plugin'
import axios from './untils/http'
import Vuex from 'vuex'
import 'babel-polyfill'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/'
//import Print from 'vue-print-nb'
import htmlToPdf from './untils/htmlToPdf'
import print from './untils/print'
import VueQuillEditor from 'vue-quill-editor'



Vue.config.productionTip = false
Vue.prototype.$message = ElementUI.Message
Vue.use(ElementUI) //使用ElementUI组件 
Vue.use(Vuex)
Vue.use(toast)
Vue.use(htmlToPdf)
Vue.use(print)
Vue.use(VueQuillEditor)
Vue.prototype.$axios = axios.axios

new Vue({
//	store,
  	el: '#app',
  	router,
  	components: { App},
  	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js